function extractProductHandle(url) {
                    if (!url) return '';
                    let cleanUrl = url.endsWith('/') ? url.slice(0, -1) : url;
                    const segments = cleanUrl.split('/');
                    return segments[segments.length - 1];
                }
function updateURLSearchanize(collection){
    // 1. Get the current URL
    const url = new URL(window.location.href);
    const params = url.searchParams;

    // 2. Remove all parameters that contain "rb_collections"
    // We use Array.from to create a list of keys so we don't 
    // mutate the object while iterating over it.
    Array.from(params.keys()).forEach(key => {
    if (key.includes('rb_collections')) {
        params.delete(key);
    }
    });

    // 3. Add or Change the 'collection' parameter
    params.set('collection', collection);

    // 4. Change 'collection' ONLY if it already exists
    if (params.has('page')) {
        params.set('page', 1);
    }

    // 5. Update the browser address bar without a page reload
    window.history.replaceState({}, '', url);
    window.location.href = url.toString();
}
function formatMoney(basePrice) {
    var formatString = window.ShopifyCurrency || { rate: 1, format: "${{amount}}" };
    var convertedPrice = parseFloat(basePrice) * formatString.rate;
    var value = convertedPrice.toFixed(2);
    var valueNoDecimals = Math.round(convertedPrice);
    return formatString.format.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, valueNoDecimals).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ',')).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, valueNoDecimals.toString().replace('.', ','));
} 
document.addEventListener('Searchanise.Loaded', function () {
    (function ($) {
        $("body").on("click", ".searchanize_menu_item", function(){
            console.log($(this).data("url"));
            updateURLSearchanize($(this).data("url"));
        }); 
        $("body").on("click", ".searchanize-filters-toggle", function(e){
            e.preventDefault();
            if (window.innerWidth > 820) return;
            const modal = document.getElementById('snize-modal-mobile-filters-dialog');
            const overlay = document.getElementById('snize-overlay-mobile-filters-dialog');
            if (!modal || !overlay) return;
            Object.assign(modal.style, {display:'block', position:'fixed', top:'0', left:'0', width:'100%', height:'100%', zIndex:'10000', background:'#fff', overflow:'auto'});
            Object.assign(overlay.style, {display:'block', position:'fixed', top:'0', left:'0', width:'100%', height:'100%', zIndex:'9999', background:'rgba(0,0,0,0.5)'});
        });
        $("body").on("click", ".stockka-custom-toolbar__filters-toggle", function(e){
            e.preventDefault();
            e.stopPropagation();

            const standaloneToggle = document.querySelector('.searchanize-filters-toggle--standalone');
            if (standaloneToggle) {
                standaloneToggle.click();
            }
        });
        $("body").on("click", ".snize_sidebar_li .icon-dropdown", function(e){
            //$(this).toggleClass("is-clicked");
            const $element = $(this).parent();

            // If it has the class, toggle the dropdown
            if ($element.hasClass('is-clicked')) {
                $element.removeClass('is-clicked');
                $element.find('> .dropdown-category-list').stop().slideUp('slow');
            }else{
                $element.addClass('is-clicked');
                $element.find('> .dropdown-category-list').stop().slideDown('slow');
            }

            // Handle clicked state for parent navigation
            if ($element.hasClass("is-clicked")) {
                //$element.closest(".navPages-item").addClass("is-clicked");
                //$element.parent().stop().slideDown("slow");
            }
        });
        $("body").on("click", "#snize-product-filters-title", function(e){
            e.preventDefault();
            $list = $(this).parent().find("> .all-categories-list");
            if ($(this).hasClass('open')) {
                $(this).removeClass('open')
                $(this).attr('aria-expanded', false);
                $list.stop().slideUp('slow');
            }else{
                $(this).addClass('open')
                $(this).attr('aria-expanded', true);
                $list.stop().slideDown('slow');
            }
        });
        $(document).on('Searchanise.AutocompleteUpdated', function (event, input, container) {
            console.log("qyuickSearch");
            $('.snize-product', container).each(function () {
                let $productCard = $(this);
                let productData = $productCard.data('snize_item_data');
                console.log($productCard);                
                console.log(productData);
                var minOrder = productData.metafield_ba7cc67ef754155ee21af439adc4bac0 || 1000;
                var delivery_days = productData.metafield_e996af021d3957de252b44dc10c991a4 || 50;
                const productHandle = extractProductHandle(productData.link);
                var colorsHTML = `<div class="stocka-color-picker allColor"><img src="${window.ShopifyAssets.no_limit_colors_icon}" width="122" height="34" alt="Color Picker" class="stocka-color-picker-icon"></div>`;
                if( productData.metafield_bc139503d084dd3e50686a842eae6086 != undefined && productData.metafield_bc139503d084dd3e50686a842eae6086 != ""){
                    colorsHTML = '<div class="card-colors">';
                    const colors = productData.metafield_bc139503d084dd3e50686a842eae6086.split(',');
                    colors.slice(0, 2).forEach(color => {
                        const trimmedColor = color.trim(); // Clean up any accidental spaces
                        colorsHTML += `
                            <label class="color" style="background-color: ${trimmedColor}">
                                <span class="text">${trimmedColor}</span>
                            </label>`;
                    });
                    if (colors.length > 2) {
                        let tooltipSwatches = '';
                        colors.forEach(color => {
                            const trimmedColor = color.trim();
                            tooltipSwatches += `<span class="card-colors__tooltip-swatch" style="background-color:${trimmedColor}" title="${trimmedColor}"></span>`;
                        });
                        colorsHTML += `<span class="color color-more" tabindex="0">+${colors.length - 2}<span class="card-colors__tooltip" role="tooltip" aria-hidden="true">${tooltipSwatches}</span></span>`;
                    }
                    colorsHTML += '</div>';
                }
                console.log(minOrder);
                console.log(delivery_days);
                $start_price = parseFloat(productData.metafield_1c6bb76df7b4b830229b94d9968be1eb);
                $end_price   = parseFloat(productData.metafield_26cd90e686cbbd088fb0c31539ee0ba8);
                var $price   = "&nbsp;";
                if( !isNaN($start_price) && !isNaN($end_price)){
                    var formattedStart = formatMoney($start_price);
                    var formattedEnd = formatMoney($end_price);
                    $price = `<span class="startPrice" data-val="${productData.metafield_1c6bb76df7b4b830229b94d9968be1eb}">${formattedStart}</span><span class="priceSeparator"> &ndash; </span><span class="endPrice" data-val="${productData.metafield_26cd90e686cbbd088fb0c31539ee0ba8}">${formattedEnd}</span>`;
                }
                const badgeHTML = `
                            <a href="/en/products/gorgeous-gift-box-1#judgeme_product_reviews" class="newlyAddedCode">
                                <div class='judgeme-reviews jdgm-widget jdgm-preview-badge' style='--rating-star-icon: url(${window.ShopifyAssets.rating_star_icon});' data-id='${productData.product_id}' data-auto-install='false'><div style='display:none' class='jdgm-prev-badge' data-average-rating='0.00' data-number-of-reviews='0' data-number-of-questions='0'> <span class='jdgm-prev-badge__stars' data-score='0.00' tabindex='0' aria-label='0.00 stars' role='button'> <span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span> </span> <span class='jdgm-prev-badge__text'> No reviews </span> </div></div>
                            </a>
                `;
                $productCard.find('.snize-thumbnail').append(badgeHTML);
                $productCard.find('.snize-title').after(`
                            <div class="card-meta-delivery-group">
                                <div class="card-meta-row">
                                    <div class="min-order"><span class="min-order__label">${window.ShopifyTranslations.min_order}</span><div class="min-order__value">${minOrder} ${window.ShopifyTranslations.pieces}</div></div>
                                    <a href="${productData.link}" class="hPro-card-price"><span class="price-range"><span class="price-range__label">${window.ShopifyTranslations.price_range}</span><span class="pro-card-price"><span class="price-value-container" style="direction: ltr;unicode-bidi: isolate-override;">${$price}</span><span class="currencySymbol"></span></span></span></a>
                                </div>
                                <div class="delivery-colors-row">
                                    <span class="delivery-details">
                                        <span class="delivery-details-para">${window.ShopifyTranslations.estimate_delivery} </span>
                                        <span class="pro-card-date-prefix">${window.ShopifyTranslations.estimate_delivery_date_prefix} </span>
                                        <span class="pro-card-date" data-days="${delivery_days}"></span>
                                    </span>
                                    ${colorsHTML}
                                </div>
                            </div>
                        `
                    );
                $productCard.find(".snize-price").remove();
                const design_online = window.ShopifyTranslations.design_online;
                const isAvailable = parseInt(productData.quantity) > 0;
                const ctaHTML = isAvailable
                    ? `<button type="button" class="product-form__submit button button--primary an- collection-design-btn" id="product-add-to-cart-${productData.product_id}" data-product-id="${productData.product_id}" data-handle="${productHandle}" data-scope="test"><img src="https://cdn.shopify.com/s/files/1/0857/3213/1122/files/design.png?v=1734114845" width="" height="" class="btn-img">${design_online}</button>`
                    : `<span class="out-of-stock-label">${window.ShopifyTranslations.out_of_stock}</span>`;
                $productCard.find('.snize-view-link').after(ctaHTML);
            });
        });
        $(document).on('Searchanise.ResultsUpdated', function (event, container) {
            $('.snize-product', container).each(function () {
                let $productCard = $(this);
                let productData = $productCard.data('snize_item_data');
                console.log($productCard);                
                console.log(productData);
                if($productCard.hasClass("stock_product_card")){
                    return false;
                }
                const productHandle = extractProductHandle(productData.link);

                var colorsHTML = `<div class="stocka-color-picker allColor"><img src="${window.ShopifyAssets.no_limit_colors_icon}" width="122" height="34" alt="Color Picker" class="stocka-color-picker-icon"></div>`;
                if( productData.metafield_bc139503d084dd3e50686a842eae6086 != undefined && productData.metafield_bc139503d084dd3e50686a842eae6086 != ""){
                    colorsHTML = '<div class="card-colors">';
                    const colors = productData.metafield_bc139503d084dd3e50686a842eae6086.split(',');
                    colors.slice(0, 2).forEach(color => {
                        const trimmedColor = color.trim(); // Clean up any accidental spaces
                        colorsHTML += `
                            <label class="color" style="background-color: ${trimmedColor}">
                                <span class="text">${trimmedColor}</span>
                            </label>`;
                    });
                    if (colors.length > 2) {
                        let tooltipSwatches = '';
                        colors.forEach(color => {
                            const trimmedColor = color.trim();
                            tooltipSwatches += `<span class="card-colors__tooltip-swatch" style="background-color:${trimmedColor}" title="${trimmedColor}"></span>`;
                        });
                        colorsHTML += `<span class="color color-more" tabindex="0">+${colors.length - 2}<span class="card-colors__tooltip" role="tooltip" aria-hidden="true">${tooltipSwatches}</span></span>`;
                    }
                    colorsHTML += '</div>';
                }
                $productCard.addClass("stock_product_card");
                $productCard.attr("id", `collection-product-details-${productData.product_id}`);
                var minOrder = productData.metafield_ba7cc67ef754155ee21af439adc4bac0 || 1000;
                var delivery_days = productData.metafield_e996af021d3957de252b44dc10c991a4 || 50;
                $start_price = parseFloat(productData.metafield_1c6bb76df7b4b830229b94d9968be1eb);
                $end_price   = parseFloat(productData.metafield_26cd90e686cbbd088fb0c31539ee0ba8);
                var $price   = "&nbsp;";
                if( !isNaN($start_price) && !isNaN($end_price)){
                    var formattedStart = formatMoney($start_price);
                    var formattedEnd = formatMoney($end_price);
                    $price = `<span class="startPrice" data-val="${productData.metafield_1c6bb76df7b4b830229b94d9968be1eb}">${formattedStart}</span><span class="priceSeparator"> &ndash; </span><span class="endPrice" data-val="${productData.metafield_26cd90e686cbbd088fb0c31539ee0ba8}">${formattedEnd}</span>`;
                }
                const badgeHTML = `
                        <a href="/en/products/gorgeous-gift-box-1#judgeme_product_reviews" class="newlyAddedCode">
                            <div class='judgeme-reviews jdgm-widget jdgm-preview-badge' style='--rating-star-icon: url(${window.ShopifyAssets.rating_star_icon});' data-id='${productData.product_id}' data-auto-install='false'><div style='display:none' class='jdgm-prev-badge' data-average-rating='0.00' data-number-of-reviews='0' data-number-of-questions='0'> <span class='jdgm-prev-badge__stars' data-score='0.00' tabindex='0' aria-label='0.00 stars' role='button'> <span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span> </span> <span class='jdgm-prev-badge__text'> No reviews </span> </div></div>
                        </a>
                `;
                $productCard.find('.snize-thumbnail').append(badgeHTML);
                $productCard.find('.snize-title').after(`
                        <div class="card-meta-delivery-group">
                            <div class="card-meta-row">
                                <div class="min-order"><span class="min-order__label">${window.ShopifyTranslations.min_order}</span><div class="min-order__value">${minOrder} ${window.ShopifyTranslations.pieces}</div></div>
                                <a href="${productData.link}" class="hPro-card-price"><span class="price-range"><span class="price-range__label">${window.ShopifyTranslations.price_range}</span><span class="pro-card-price"><span class="price-value-container" style="direction: ltr;unicode-bidi: isolate-override;">${$price}</span><span class="currencySymbol"></span></span></span></a>
                            </div>
                            <div class="delivery-colors-row">
                                <span class="delivery-details">
                                    <span class="delivery-details-para">${window.ShopifyTranslations.estimate_delivery} </span>
                                    <span class="pro-card-date-prefix">${window.ShopifyTranslations.estimate_delivery_date_prefix} </span>
                                    <span class="pro-card-date" data-days="${delivery_days}"></span>
                                </span>
                                ${colorsHTML}
                            </div>
                        </div>
                    `
                );
                $productCard.find(".snize-price").remove();
                const design_online = window.ShopifyTranslations.design_online;
                const isAvailable = parseInt(productData.quantity) > 0;
                const ctaHTML = isAvailable
                    ? `<button type="button" class="product-form__submit button button--primary an- collection-design-btn" id="product-add-to-cart-${productData.product_id}" data-product-id="${productData.product_id}" data-handle="${productHandle}" data-scope="test"><img src="https://cdn.shopify.com/s/files/1/0857/3213/1122/files/design.png?v=1734114845" width="" height="" class="btn-img">${design_online}</button>`
                    : `<span class="out-of-stock-label">${window.ShopifyTranslations.out_of_stock}</span>`;
                $productCard.find('.snize-view-link').after(ctaHTML);

                

                

            });
            $("#snize_filters_block_collections").remove();
            $(".snize-filters-sidebar #searchanizeTrendingProductsI").remove();
            const content = $('#searchanizeCollections').html();
            const contentTrending = $('#searchanizeTrendingProducts').html();
            $(".snize-filters-sidebar.snize-product-filters").append(content).append(contentTrending);        
        });
        $("body #snize_results").addClass("cacat");
    })(window.Searchanise.$);
});
//ADD GRID BUTTONS
const STORAGE_KEY = 'snize_grid_columns';
const GRID_SELECTOR = '#snize-search-results-grid-mode';
const TOGGLE_SELECTOR = '.searchanizeToggleColumns';

function getSearchanizeDefaultColumnClass() {
    if (window.innerWidth < 600) {
        return 'snize-two-columns';
    }

    return window.innerWidth > 1024 ? 'snize-four-columns' : 'snize-three-columns';
}

function getSearchanizeAllowedColumnClasses() {
    if (window.innerWidth < 600) {
        return ['snize-two-columns'];
    }

    return window.innerWidth > 1024
        ? ['snize-three-columns', 'snize-four-columns']
        : ['snize-two-columns', 'snize-three-columns'];
}

function applyColumnClass(className) {
    var $grid = $(GRID_SELECTOR);

    // Find all possible column classes from the buttons to ensure we clean up correctly
    var allPossibleClasses = $(TOGGLE_SELECTOR).map(function() {
        return $(this).data('col');
    }).get().join(' ');

    // Remove old classes and add the new one
    $grid.removeClass(allPossibleClasses).addClass(className);

    var $buttons = $(TOGGLE_SELECTOR);
    $buttons.removeClass("active");    
    $buttons.filter(function() {
        return $(this).data('col') == className;
    }).addClass("active");

    document.querySelectorAll('.stockka-custom-toolbar__grid-button').forEach((button) => {
        const image = button.querySelector('img[data-default-src][data-active-src]');
        if (!image) return;

        const isActive = button.classList.contains('active');
        image.src = isActive ? image.dataset.activeSrc : image.dataset.defaultSrc;
    });

    // Save to local storage
    localStorage.setItem(STORAGE_KEY, className);

    window.requestAnimationFrame(() => {
        window.requestAnimationFrame(syncSearchanizeSmallCardState);
    });
}

function syncSearchanizeColumnState(forceDefault) {
    var savedClass = localStorage.getItem(STORAGE_KEY);
    var defaultClass = getSearchanizeDefaultColumnClass();
    var allowedClasses = getSearchanizeAllowedColumnClasses();
    var targetClass = forceDefault ? defaultClass : savedClass;

    if (!allowedClasses.includes(targetClass)) {
        targetClass = defaultClass;
    }

    applyColumnClass(targetClass);
}

function ensureSearchanizeClearColorOption() {
    const filterLists = document.querySelectorAll('div.snize ul.snize-product-color-filter');
    filterLists.forEach((list) => {
        let item = list.querySelector('.snize-clear-color-option');
        if (!item) {
            item = document.createElement('li');
            item.className = 'snize-clear-color-option';
            item.innerHTML = `
                <button type="button" class="snize-clear-color-button" aria-label="Clear color filter">
                    <img src="${window.ShopifyAssets.no_limit_colors_icon}" alt="">
                </button>
            `;
        }

        list.appendChild(item);
    });
}

function ensureSearchanizePaginationArrows() {
    const nextLinks = document.querySelectorAll('div.snize div.snize-pagination ul li .snize-pagination-next');
    const prevLinks = document.querySelectorAll('div.snize div.snize-pagination ul li .snize-pagination-prev');

    nextLinks.forEach((link) => {
        link.innerHTML = `
            <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                <path d="M12.5 4.25 6.75 10l5.75 5.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
            </svg>
        `;
    });

    prevLinks.forEach((link) => {
        link.innerHTML = `
            <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                <path d="m7.5 4.25 5.75 5.75-5.75 5.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
            </svg>
        `;
    });
}

function moveSearchanizeFiltersToggleIntoMainPanel() {
    const resultsRoot = document.querySelector('#snize_results');
    const toggle = document.querySelector('.searchanize-filters-toggle--standalone');
    const mainPanel = resultsRoot ? resultsRoot.querySelector('.snize-main-panel') : null;

    if (!toggle || !mainPanel) return;
    if (toggle.parentElement === mainPanel) return;

    mainPanel.prepend(toggle);
}

function moveSearchanizeDropdownIntoMainPanel() {
    if (window.innerWidth > 820) return;

    const resultsRoot = document.querySelector('#snize_results');
    const mainPanel = resultsRoot ? resultsRoot.querySelector('.snize-main-panel') : null;
    const dropdown = resultsRoot ? resultsRoot.querySelector('.snize-main-panel-dropdown') : null;

    if (!mainPanel || !dropdown) return;
    if (dropdown.parentElement === mainPanel) return;

    mainPanel.appendChild(dropdown);
}

function moveSearchanizeViewAsIntoMainPanel() {
    if (window.innerWidth > 820) return;

    const resultsRoot = document.querySelector('#snize_results');
    const mainPanel = resultsRoot ? resultsRoot.querySelector('.snize-main-panel') : null;
    const desktopViewAs = resultsRoot ? resultsRoot.querySelector('.snize-horizontal-left .toolbar-item.toolbar-viewAs') : null;

    if (!mainPanel || !desktopViewAs) return;

    const existingMobileViewAs = mainPanel.querySelector('.searchanize-toolbar-viewAs');
    if (existingMobileViewAs) {
        existingMobileViewAs.remove();
    }

    const mobileViewAs = desktopViewAs.cloneNode(true);
    mobileViewAs.classList.add('searchanize-toolbar-viewAs');

    const dropdown = mainPanel.querySelector('.snize-main-panel-dropdown');
    if (dropdown) {
        mainPanel.insertBefore(mobileViewAs, dropdown);
    } else {
        mainPanel.appendChild(mobileViewAs);
    }
}

function syncForcedSearchanizeMobileMode() {
    const resultsRoot = document.querySelector('#snize_results');
    if (!resultsRoot) return;

    if (window.innerWidth <= 820) {
        resultsRoot.classList.add('snize-mobile-design');
    } else {
        resultsRoot.classList.remove('snize-mobile-design');
    }
}

function initializeSearchanizeMobileFilters() {
    const resultsRoot = document.querySelector('#snize_results');
    if (!resultsRoot) return;

    if (window.innerWidth > 820) {
        resultsRoot.removeAttribute('data-stockka-mobile-filters-initialized');
        return;
    }

    if (resultsRoot.getAttribute('data-stockka-mobile-filters-initialized') === 'true') return;

    const trigger = resultsRoot.querySelector('div.snize-main-panel-mobile-filters > a');
    if (!trigger) return;

    resultsRoot.setAttribute('data-stockka-mobile-filters-initialized', 'true');
    trigger.click();

    window.setTimeout(() => {
        const closeButton = document.querySelector(
            '#snize-modal-mobile-filters-dialog .snize-close-button-arrow, ' +
            '#snize-modal-mobile-filters-dialog .snize-mobile-top-panel button, ' +
            '#snize-modal-mobile-filters-dialog button[class*="close"]'
        );

        if (closeButton) {
            closeButton.click();
        }
    }, 150);
}

function syncCustomSearchToolbarSortSelector() {
    const customToolbar = document.querySelector('.stockka-custom-toolbar');
    const sourceDropdown = document.querySelector('#snize_results .snize-main-panel-dropdown');
    const currentLabel = sourceDropdown ? sourceDropdown.querySelector(':scope > a') : null;
    const sortOptions = sourceDropdown ? sourceDropdown.querySelectorAll('#snize-sorting-options-list a') : [];

    if (!customToolbar || !sourceDropdown || !sortOptions.length) return;

    const existingSelect = customToolbar.querySelector('.stockka-custom-toolbar__sort-select');
    if (existingSelect) {
        existingSelect.remove();
    }

    const select = document.createElement('select');
    select.className = 'stockka-custom-toolbar__sort-select';

    sortOptions.forEach((link) => {
        const option = document.createElement('option');
        option.value = link.className;
        option.textContent = link.textContent.trim();

        if (currentLabel && option.textContent === currentLabel.textContent.trim()) {
            option.selected = true;
        }

        select.appendChild(option);
    });

    customToolbar.appendChild(select);
}

function syncSearchanizeSmallCardState() {
    const cards = document.querySelectorAll('#snize-search-results-grid-mode li.snize-product');

    cards.forEach((card) => {
        const isSmall = card.offsetWidth > 0 && card.offsetWidth < 250;
        card.classList.toggle('stockka-search-card-small', isSmall);
    });
}

$(document).on('click', '.snize-clear-color-button', function(e) {
    e.preventDefault();

    const $list = $(this).closest('ul.snize-product-color-filter');
    const $checkedInputs = $list.find('.snize-color-filter-checkbox input[type=checkbox]:checked');

    if (!$checkedInputs.length) return;

    $checkedInputs.each(function() {
        this.click();
    });
});

$(document).on('click', TOGGLE_SELECTOR, function(e) {
    e.preventDefault();
    $(TOGGLE_SELECTOR).removeClass("active")
     $(this).addClass("active");
    var colClass = $(this).data('col');
    applyColumnClass(colClass);
});

$(document).on('change', '.stockka-custom-toolbar__sort-select', function() {
    const selectedClass = this.value;
    const sourceLink = document.querySelector(`#snize_results .snize-main-panel-dropdown #snize-sorting-options-list a.${selectedClass.replace(/\s+/g, '.')}`);

    if (sourceLink) {
        sourceLink.click();
    }
});

window.addEventListener('resize', syncForcedSearchanizeMobileMode);
window.addEventListener('resize', initializeSearchanizeMobileFilters);
window.addEventListener('resize', function() {
    syncSearchanizeColumnState(false);
    syncSearchanizeSmallCardState();
});

$(document).on('Searchanise.ResultsUpdated', function(event, container) {
    console.log("TESTTTTTTTT");
    $("body #snize_results").addClass("pisat");
    $("#sortBySearchanize").remove();
    $(".snize-main-panel-dropdown").prepend(`
            <span id="sortBySearchanize">${window.ShopifyTranslations.sort_by}</span>
         `
    );
    $("#snize_results .snize-horizontal-left").empty().append(`
                                                                <div class="toolbar"><div class="toolbar-col toolbar-colLeft">
                                                                    <label class="toolbar-label">${window.ShopifyTranslations.view_as}</label>
                                                                    <div class="toolbar-item toolbar-viewAs clearfix" data-view-as="">
                                                                        <span class="toolbar-icon icon-mode icon-mode-grid grid-3 searchanizeToggleColumns" data-col="snize-three-columns" role="button" aria-label="Grid 3" tabindex="0"></span>
                                                                        <span class="toolbar-icon icon-mode icon-mode-grid grid-4 searchanizeToggleColumns" data-col="snize-four-columns" role="button" aria-label="Grid 4" tabindex="0"></span>
                                                                        <span class="toolbar-icon icon-mode icon-mode-grid grid-5 searchanizeToggleColumns" data-col="snize-five-columns" role="button" aria-label="Grid 5" tabindex="0"></span>
                                                                    </div>
                                                                </div></div>
                                                            `
                                                        );
    const resultsRoot = document.querySelector('#snize_results');
    const shouldForceDefault = !resultsRoot || resultsRoot.getAttribute('data-stockka-grid-initialized') !== 'true';
    syncSearchanizeColumnState(shouldForceDefault);
    if (resultsRoot) {
        resultsRoot.setAttribute('data-stockka-grid-initialized', 'true');
    }
    //SET 0.1 price filter steps
    var inputs = document.querySelectorAll('.snize-price-range-input');
      
      inputs.forEach(function(input) {
        // Setting step to "0.1" allows typing 10.5, 10.2, etc.
        // Use "0.01" if you need cents (10.99).
        input.setAttribute('step', '0.1'); 
      });

    ensureSearchanizeClearColorOption();
    ensureSearchanizePaginationArrows();
    moveSearchanizeFiltersToggleIntoMainPanel();
    moveSearchanizeDropdownIntoMainPanel();
    moveSearchanizeViewAsIntoMainPanel();
    syncForcedSearchanizeMobileMode();
    initializeSearchanizeMobileFilters();
    syncCustomSearchToolbarSortSelector();
    window.requestAnimationFrame(() => {
        window.requestAnimationFrame(syncSearchanizeSmallCardState);
    });

});
